// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__pvSS5","jobTitle":"Header_jobTitle__xXCwu","details":"Header_details__DPuKw","separator":"Header_separator__xl0l7","location":"Header_location__yHfVI"};